import { autoinject, PLATFORM } from 'aurelia-framework';
import './pen-order-view.scss';
import { Tab } from 'elements/tabs/MnTabs';
import { I18N } from 'aurelia-i18n';
import { AsyncErrorHandler } from 'lib/ui';
import { PenOrderStatusService } from 'services/pen/pen-order-status-service';
import { PenOrderStatusDto } from 'models/pen/PenOrderStatus';
import { Router } from 'aurelia-router';
import { DialogService } from 'aurelia-dialog';
import { Prompt } from 'elements/prompt';
import { PenOrderService } from 'services/pen/pen-order-service';
import { ToastService } from 'services';
import { EventAggregator } from 'aurelia-event-aggregator';
import { PenOrderDto } from 'models/pen/PenOrder';
import { ConfirmDialog } from 'components/dialogs/confirm/confirm-dialog';
import { PubSub } from 'lib/event/PubSub';

@autoinject
export class PensOrderView {
  protected penOrderId: number;
  protected penOrder: PenOrderDto;
  protected penId: number;
  protected penOrderStatusDto: PenOrderStatusDto[];
  protected tabsReady = false;
  protected tabs: Tab[] = [
    {
      name: 'order-details',
      title: this.t.tr('notlogg.orderdetails'),
      view: PLATFORM.moduleName('views/pens/pens-orders/order-details/tab'),
      data: {},
    },
    // {
    //   name: 'analysis-and-drawing',
    //   title: this.t.tr('notlogg.AnalysisAndDrawing'),
    //   view: PLATFORM.moduleName('views/pens/pens-orders/analysis/tab'),
    //   data: {},
    // },
    // {
    //   name: 'mounting',
    //   title: this.t.tr('notlogg.Mounting'),
    //   view: PLATFORM.moduleName('views/pens/pens-orders/mounting/tab'),
    //   data: {},
    // },
    // {
    //   name: 'material-consumption',
    //   title: this.t.tr('notlogg.MaterialConsumption'),
    //   view: PLATFORM.moduleName('views/pens/pens-orders/material-consumption/tab'),
    //   data: {},
    // },
    // {
    //   name: 'installation',
    //   title: this.t.tr('notlogg.Installation'),
    //   view: PLATFORM.moduleName('views/pens/pens-orders/installation/tab'),
    //   data: {},
    // },
    // {
    //   name: 'signing',
    //   title: this.t.tr('notlogg.signingTab'),
    //   view: PLATFORM.moduleName('views/pens/pens-orders/signing/tab'),
    //   data: {},
    // },
    // {
    //   name: 'hours',
    //   title: this.t.tr('service.hoursTab'),
    //   view: PLATFORM.moduleName('views/pens/pens-orders/hours/tab'),
    //   data: {},
    // },
  ];

  constructor(
    private t: I18N,
    private penOrderStatusService: PenOrderStatusService,
    private penOrderService: PenOrderService,
    private router: Router,
    private confirmation: ConfirmDialog,
    private pubSub: PubSub,
    private dialogService: DialogService,
    private toastService: ToastService,
    private eventAggregator: EventAggregator
  ) {
    pubSub.sub('entity:updated', this.getOrder.bind(this));
  }

  async attached() {
    await this.getOrder();
    await this.getStatuses();
  }

  activate(params: { penOrderId: number; penId: number }) {
    this.penOrderId = params.penOrderId;
    this.penId = params.penId;
  }

  @AsyncErrorHandler
  async getOrder() {
    this.tabsReady = false;
    const { data } = await this.penOrderService.getOrder(this.penOrderId);

    this.penOrder = data;

    for (const tab of this.tabs) {
      if (!tab.data) tab.data = {};
      tab.data = {
        penOrderId: this.penOrderId,
        penId: this.penId,
      };
    }

    this.tabsReady = true;
  }

  @AsyncErrorHandler
  async getStatuses() {
    this.penOrderStatusDto = await this.penOrderStatusService.getAll();
  }

  protected confirmBeforeCreatePens() {
    return this.dialogService
      .open({
        viewModel: Prompt,
        model: {
          header: 'dialog.createPensHeading',
          message: 'dialog.createPensAreYouSure',
          actions: {
            delete: { enabled: false },
            save: { enabled: false },
            cancel: { enabled: true, t: 'dialog.cancel' },
            dontsave: { enabled: false },
            continue: { enabled: true, t: 'dialog.createPens' },
            createNets: { enabled: false },
          },
        },
      })
      .whenClosed((response) => {
        if (response.wasCancelled) {
          return false;
        } else {
          const result = response.output;
          if (result === 'continue') {
            this.createPens();
            return false;
          } else {
            return true;
          }
        }
      });
  }

  @AsyncErrorHandler
  async createPens() {
    await this.penOrderService.createPens(this.penOrderId);
    this.toastService.showSuccess('order.pensCreated');
    this.eventAggregator.publish('pens-created');
    this.pubSub.publish('entity:updated', null);
  }

  @AsyncErrorHandler
  async changeOrderStatus(penOrderStatus: PenOrderStatusDto) {
    const confirmed = await this.confirmation.confirmYesCancel(
      'general.changeOrderStatus',
      this.t.tr('general.changeOrderStatusConfirmation', { x: this.t.tr(penOrderStatus.Name) })
    );
    if (!confirmed) return;
    await this.penOrderService.updateOrderStatus(this.penOrderId, penOrderStatus);

    this.pubSub.publish('entity:updated', null);
  }
}
